import React from 'react'

const { Consumer, Provider } = React.createContext()

export const ModalConsumer = Consumer
export const ModalProvider = Provider
